export default __webpack_public_path__ + "static/media/downloadwebp.5499084a.webp";